import { Link } from 'react-router-dom';
import { PremiumHeader } from '@/components/premium/PremiumHeader';
import { PremiumFooter } from '@/components/premium/PremiumFooter';
import { SEO } from '@/components/SEO';

const CATEGORIES = [
  { name: 'Modular Office Workstations', url: '/products?category=Modular+Office+Workstation', subs: ['Cluster of 2', 'Cluster of 4', 'Cluster of 4 Large'] },
  { name: 'Privacy Booths & Phone Pods', url: '/products?category=Privacy+Booths', subs: ['1 Seater Pod', '2 Seater Pod', '4 Seater Pod', '6 Seater Pod'] },
  { name: 'Storage Cabinets & Solutions', url: '/products?category=Storage+Cabinets', subs: ['Sliding Door', 'Filing Cabinet', 'Under-Desk Pedestal', 'Credenza'] },
];

const INFO_PAGES = [
  { name: 'About MFS', url: '/about' },
  { name: 'Our Legacy', url: '/legacy' },
  { name: 'Delivered Workspaces / Projects', url: '/projects' },
  { name: 'Knowledge Hub / Blog', url: '/blog' },
  { name: 'Contact Us', url: '/contact' },
  { name: 'Bulk Inquiry', url: '/bulk-inquiry' },
  { name: 'Pricing Guide', url: '/pricing-guide' },
  { name: 'Furniture Comparison Guide', url: '/comparison-guide' },
  { name: 'Policies', url: '/policies' },
];

const CITY_PAGES = [
  { name: 'Office Furniture Mumbai', url: '/office-furniture-mumbai' },
  { name: 'Office Furniture Navi Mumbai', url: '/office-furniture-navi-mumbai' },
  { name: 'Office Furniture Thane', url: '/office-furniture-thane' },
  { name: 'Office Furniture Pune', url: '/office-furniture-pune' },
  { name: 'Office Furniture Bengaluru', url: '/office-furniture-bengaluru' },
  { name: 'Office Furniture Delhi NCR (Gurugram)', url: '/office-furniture-gurugram' },
  { name: 'Office Furniture Hyderabad', url: '/office-furniture-hyderabad' },
  { name: 'Office Furniture Chennai', url: '/office-furniture-chennai' },
  { name: 'Office Furniture Ahmedabad', url: '/office-furniture-ahmedabad' },
  { name: 'Office Furniture BKC Mumbai', url: '/office-furniture-bkc-mumbai' },
  { name: 'Office Furniture Andheri & Powai', url: '/office-furniture-andheri-powai' },
];

export default function HtmlSitemap() {
  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: 'Manrope, sans-serif' }}>
      <SEO
        title="Sitemap | Modular Furniture Store"
        description="Complete sitemap of Modular Furniture Store — browse all product categories, office furniture collections, city pages, and information pages."
        canonical="/sitemap"
      />
      <PremiumHeader />

      <div className="container mx-auto px-4 sm:px-8 py-16 max-w-5xl">
        <h1 className="text-2xl sm:text-3xl font-extrabold text-[#1a1a1a] uppercase tracking-tight mb-2">Sitemap</h1>
        <p className="text-gray-500 text-sm mb-12">Complete index of all pages on modularfurniturestore.com</p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
          {/* Product Categories */}
          <div>
            <h2 className="text-sm font-extrabold text-[#c5a059] uppercase tracking-[0.2em] mb-4 border-b border-[#c5a059] pb-2">Product Categories</h2>
            <ul className="space-y-3">
              <li><Link to="/products" className="text-sm text-[#1a1a1a] hover:text-[#c5a059] font-semibold transition-colors">All Products</Link></li>
              {CATEGORIES.map(cat => (
                <li key={cat.name}>
                  <Link to={cat.url} className="text-sm text-[#1a1a1a] hover:text-[#c5a059] font-semibold transition-colors">{cat.name}</Link>
                  <ul className="mt-1 ml-4 space-y-1">
                    {cat.subs.map(sub => (
                      <li key={sub}>
                        <Link to={`${cat.url}&subcategory=${encodeURIComponent(sub)}`} className="text-xs text-gray-500 hover:text-[#c5a059] transition-colors">
                          {sub}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </li>
              ))}
            </ul>
          </div>

          {/* Information Pages */}
          <div>
            <h2 className="text-sm font-extrabold text-[#c5a059] uppercase tracking-[0.2em] mb-4 border-b border-[#c5a059] pb-2">Information</h2>
            <ul className="space-y-3">
              {INFO_PAGES.map(page => (
                <li key={page.name}>
                  <Link to={page.url} className="text-sm text-[#1a1a1a] hover:text-[#c5a059] font-medium transition-colors">{page.name}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* City / Local Pages */}
          <div>
            <h2 className="text-sm font-extrabold text-[#c5a059] uppercase tracking-[0.2em] mb-4 border-b border-[#c5a059] pb-2">City Pages</h2>
            <ul className="space-y-3">
              {CITY_PAGES.map(page => (
                <li key={page.name}>
                  <Link to={page.url} className="text-sm text-[#1a1a1a] hover:text-[#c5a059] font-medium transition-colors">{page.name}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <PremiumFooter />
    </div>
  );
}
